import { KeyConstructor } from './keyConstructor';
const SPACE_POST_TYPE_KEY = 'spacePostType';
const SPACE_POST_TYPES_KEY = 'spacePostTypes';
export const getSpacePostTypeKey = KeyConstructor(SPACE_POST_TYPE_KEY);
export const getSpacePostTypesKey = KeyConstructor(SPACE_POST_TYPES_KEY);
//# sourceMappingURL=spacePostType.key.js.map